import { useTranslation } from 'react-i18next';
import { I18nKey } from '../../../i18n/i18n.key';
import { Question } from '../../../response/test.response';
import { memo } from 'react';
import { CustomTextView } from '../../../view/custom-text.view';
import ParagraphNavigationComponent from './paragraph-navigation.component';
import { useApp } from '../../../hook/app.hook';
import { getLanguageContent } from '../../../util/language.util';
import { QuestionFormat } from '../../../enum/question-format';

export interface QuestionComponentProps {
  question: Question;
}

const QuestionComponent: React.FC<QuestionComponentProps> = ({ question }) => {
  const { t } = useTranslation();
  const { language } = useApp();

  return (
    <div className="d-flex flex-column question--h">
      <div className="pt-2 question--area">
        {question.paragraph?.isParagraph && (
          <div className="mb-2">
            <ParagraphNavigationComponent currentQuestion={question} />
            <h6 className="text-dark font-weight-700 mb-0">Paragraph: -</h6>
            <CustomTextView
              initData={getLanguageContent(
                question.paragraph.paragraph,
                language,
              )}
              format={
                question.format.length > 0
                  ? question.format
                  : QuestionFormat.RICH_HTML
              }
            />
            <h6 className="text-dark font-weight-700 mb-0">Question: -</h6>
          </div>
        )}
        <CustomTextView
          initData={getLanguageContent(question.description, language)}
          format={
            question.format.length > 0
              ? question.format
              : QuestionFormat.RICH_HTML
          }
        />
      </div>
      <div className="mt-auto my-4 d-flex align-items-center text-end">
        <div className="ms-auto">
          <span>{t(I18nKey.POSITIVE_MARKING_TEXT)}:</span>
          <span className="font-weight-600 ms-1">
            +{question.marking.positive}
          </span>
        </div>
        <div className="ms-2">
          <span className="border-start border-dimgray ps-2">
            {t(I18nKey.NEGATIVE_MARKETING_TEXT)}:
          </span>
          <span className="font-weight-600 ms-1 text-danger">
            {question.marking.negative}
          </span>
        </div>
      </div>
    </div>
  );
};

export default memo(QuestionComponent);
